import { createFileRoute } from "@tanstack/react-router";
import VisitorInquiryPage from "@project/user/pages/community/visitor-inquiry";

export const Route = createFileRoute("/_user/_community/visitor-inquiry")({
  head: () => ({
    meta: [
      { title: "Visitor Inquiry — Jivandhara Vruddhashram" },
      {
        name: "description",
        content:
          "Plan a visit to Jivandhara Old Age Home. Share visit details, reason for visit, and reference information.",
      },
      { property: "og:title", content: "Visitor Inquiry — Jivandhara" },
      {
        property: "og:description",
        content: "Register a planned visit to Jivandhara Old Age Home.",
      },
    ],
  }),
  component: VisitorInquiryPage,
});
